import { DetailsTooltip } from "../../components/Tooltips/DetailsTooltip/DetailsTooltip"
import { useDbStateStore } from "../../zstore/DbStateStore"

export const VersionTooltip = () => {
    const { dbState, success } = useDbStateStore()
    const { databaseName, databaseVersion, backendVersion } = dbState ?? {}

    return (
        <DetailsTooltip
            label="Version Info"
            details={[
                { label: "Nexus Version", value: backendVersion },
                { label: "Database Name", value: databaseName },
                { label: "Node Env", value: import.meta.env.MODE },
                { label: "PostgreSQL Version", value: databaseVersion },
            ]}
            // animate
            disabled={success == null}
        />
    )
}
